import {Component} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {ChartParams} from "../../views/chart/chart.component";

import * as qs from 'clever-qs';
import { BillingService2 } from "../billing.service";
import { IStatResult } from "../../models/responce_result.model";


interface IReturnStats extends IStatResult {
	count: number;
	sum: number;
}

@Component({
	selector: 'return',
	templateUrl: './return.component.html',
	styles: [`
		.tooltip-custom-class .tooltip-inner {
			background-color: darkgreen;
		}

		.tooltip-custom-class .arrow::before {
			border-top-color: darkgreen;
		}
	`]
})
export class ReturnComponent extends BaseComponent {
	returnChart = new ChartParams({
		filter: {
			datePeriodList: []
		}
	});
	
	count = 0;
	sum   = 0;
	
	addFilterParams = {
		userType      : 'user',
		isExpiredPaid : true,
		dateFilters   : ['dateReturn', 'datePaid', 'dateCreated', 'dateSiteCreated'],
		dateType      : 'dateReturn',
	};

	constructor(
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		public router: Router,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		this.returnChart.setOptions({
			title: this.translate.__A('common.Returns'),
			showLabels: [
				'moneyCount', 'count'
			],
			names: {
				'count': this.translate.__A('common.Count'),
				'moneyCount': this.translate.__A('common.total'),
			},
			data: {
				axes: {
					moneyCount: 'y',
					count: 'y2'
				}
			},
			axes: {
				moneyCount: 'y',
				count: 'y2'
			},
			axis: {
				x: {
					tick: {
						fit: false,
						format: '%d-%m-%Y'
					}
				},
				y2: {
					show: true
				}
			}
		});
	}


	async getData() {
		await this.getChart();
		await this.getPagination();
	}


	async getPagination() {
		let me = this;

		if (this.dontLoad.pagination) {
			await this.getStats();
			return true;
		}

		this.paginationLoader = true;

		const pagination = await this.service2.return.pagination(
			this.filter.filterParams
		).toPromise();
		me.pagination.fill(pagination);
		
		if (pagination) {
			me.updateLinks(
				me.service2.return.getRealFullRoute()
			)
		}

		this.paginationLoader = false;

		await this.getStats();
	}


	async getStats() {
		const me = this;

		const fp = me.filter.getFilterParams();
		fp.paginationDate = me.pagination.getDate();

		me.stats = [];
		me.count = 0;
		me.sum = 0;

		this.paginationLoader = true;
		const { count, sum, stats } = await me.service2.return.stats<IReturnStats>(fp).toPromise();
		this.paginationLoader = false;

		me.stats = stats;
		me.count = count;
		me.sum   = sum;
	}


	async getChart() {
		const me = this;

		if (this.dontLoad.chart) {
			return true;
		}

		const fp = me.filter.getFilterParams();

		me.returnChart.showLoader();
		const { charts } = await me.service2.return.chart(fp).toPromise();
		me.returnChart.data = charts;
		me.returnChart.hideLoader();
	}


	getTotalAmount() {
		return this.stats.reduce((count, stat) => count + stat.usdAmount, 0);
	}


	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;

		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params = this.filter.getApplyFilters(this.filter.filterParams);
		const url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});

		this.dontLoad = {
			chart: true,
			pagination: true
		};
	}
}
